import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "catalog-options" }
const _hoisted_2 = { class: "options-headline" }
const _hoisted_3 = { class: "test-connection-wrapper my-3" }
const _hoisted_4 = { class: "d-flex align-items-center gap-2 alert-text-align" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col" }
const _hoisted_7 = { class: "d-flex flex-column" }
const _hoisted_8 = { class: "font-weight-bold" }
const _hoisted_9 = { class: "col dropdown-right" }
const _hoisted_10 = { class: "font-weight-bold" }
const _hoisted_11 = { key: 0 }

import MSelect from "@/BasicComponentLibrary/MSelect.vue";
import Dropdown from "@/common/components/Dropdown.vue";
import articleNumberTypesApi from "@/services/articleNumberTypes";
import Alert from "@common/components/Alert.vue";
import Spinner from "@common/components/Spinner.vue";
import externalDataApi from "@services/externalData";
import { computed, onMounted, reactive, watch } from "vue";
import { useI18n } from "vue-i18n";

type ViewModel = {
  connectionState: boolean | null;
  externalDataConnection: string;
  artNrType: number;
  artNrSource: number | null;
  artNrTypesFetched: Array<{ name: string; articleNumberType: string }>;
  artNrSourcesFetched: string[];
  errorMessage: string;
  isLoading: boolean;
  selectedCommands: Array<{
    connectionName: string;
    selectionCommands: Array<{ id: string; name: string }>;
  }> | null;
  singleColumnName: string | null;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'CatalogOptionsExternal',
  props: {
    fields: {},
    groupedCommands: {},
    direction: {}
  },
  emits: ["stepChange", "selectedExternalData"],
  setup(__props: any, { emit: emits }) {

const props = __props;

const { t: $t } = useI18n();

//#region Props & Emits




//#endregion

//#region ViewModel
const vm = reactive<ViewModel>({
  connectionState: null,
  externalDataConnection: "",
  artNrType: props.fields ? props.fields.artNrTypeSelected : 0,
  artNrSource: props.fields ? props.fields.artNrSourceSelected : null,
  artNrTypesFetched: [],
  artNrSourcesFetched: [],
  errorMessage: "",
  isLoading: false,
  selectedCommands: null,
  singleColumnName: null
});

//#endregion

//#region Lifecycle
onMounted(() => {
  getAllSelectionCommandsGrouped();
  getArtNrTypes();
});
//#endregion

const artNrTypeFields = computed(() => {
  return vm.artNrTypesFetched.map((x, index) => ({
    text: x.name,
    value: index
  }));
});

const formatedConnectionStrings = computed(() => {
  if (!vm.selectedCommands || !Array.isArray(vm.selectedCommands)) return {};

  return vm.selectedCommands.reduce((acc: Record<string, Array<{ id: string; name: string }>>, item) => {
    acc[item.connectionName] = item.selectionCommands.map((cmd) => ({
      id: cmd.id,
      name: cmd.name
    }));
    return acc;
  }, {});
});

async function getAllSelectionCommandsGrouped() {
  try {
    vm.selectedCommands = await externalDataApi.getAllSelectionCommandsGrouped();
  } catch (err) {
    console.error("External data api failed:", err);
  }
}

const checkArticleNrType = (selectedArtNrType: string) => {
  let isDefault = false;
  vm.artNrTypesFetched.map((artNrType) => {
    if (artNrType.name === selectedArtNrType && artNrType.articleNumberType === "Default") isDefault = true;
  });
  return isDefault;
};

async function getArtNrTypes() {
  try {
    vm.artNrTypesFetched = await articleNumberTypesApi.get();
  } catch (err) {
    console.error("External data api failed:", err);
  }
}

watch(
  () => vm.artNrType,
  () => {
    emits("selectedExternalData", {
      singleColumnName: vm.singleColumnName,
      fields: {
        artNrTypeSelected: vm.artNrType,
        artNrSourceSelected: vm.artNrSource
      },
      connectionState: vm.connectionState
    });
  }
);

watch(
  () => vm.singleColumnName,
  () => {
    const artNrTypeName = vm.artNrTypesFetched[vm.artNrType]?.name;
    emits("selectedExternalData", {
      singleColumnName: vm.singleColumnName,
      commandId: vm.externalDataConnection,
      selectedArticleNumberType: {
        articleNumberType: checkArticleNrType(artNrTypeName) ? 0 : 1,
        name: artNrTypeName
      },
      connectionState: vm.connectionState
    });
  }
);

watch(
  () => vm.externalDataConnection,
  async () => {
    vm.singleColumnName = null;
    try {
      vm.isLoading = true;
      vm.singleColumnName = await externalDataApi.getSourceColumnNameOfSelectionCommand(vm.externalDataConnection);

      if (vm.singleColumnName && vm.singleColumnName.length === 1) {
        vm.connectionState = true;
      }
    } catch (err: any) {
      vm.errorMessage = err.status === 409 ? err.response.data : $t("GenerateCatalogFromExternalData.ConnectionFailed");
      vm.connectionState = false;
    } finally {
      vm.isLoading = false;
    }
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", null, _toDisplayString(_unref($t)("GenerateCatalogFromExternalData.CatalogOptions.InfoText")), 1),
    _createElementVNode("p", _hoisted_2, _toDisplayString(_unref($t)("GenerateCatalogFromExternalData.ExternalDataSource")), 1),
    _createVNode(MSelect, {
      modelValue: vm.externalDataConnection,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((vm.externalDataConnection) = $event)),
      items: formatedConnectionStrings.value,
      textField: "name",
      valueField: "id"
    }, null, 8, ["modelValue", "items"]),
    _createElementVNode("div", _hoisted_3, [
      (vm.isLoading)
        ? (_openBlock(), _createBlock(Alert, {
            key: "loading",
            show: true,
            class: "connection-alert w-100 m-0"
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_4, [
                _createVNode(Spinner, { size: 20 }),
                _createTextVNode(" " + _toDisplayString(_unref($t)("GenerateCatalogFromExternalData.testingConnectionMessage")), 1)
              ])
            ]),
            _: 1
          }))
        : (!!vm.externalDataConnection && vm.connectionState !== null)
          ? (_openBlock(), _createBlock(Alert, {
              key: "status",
              show: true,
              class: "connection-alert w-100 m-0",
              "with-icon": "",
              variant: vm.connectionState ? 'success' : 'danger'
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(vm.connectionState ? _unref($t)("GenerateCatalogFromExternalData.ConnectionEstablished") : vm.errorMessage), 1)
              ]),
              _: 1
            }, 8, ["variant"]))
          : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("label", _hoisted_8, _toDisplayString(_unref($t)("Source")), 1),
          _createElementVNode("span", null, _toDisplayString(vm.singleColumnName ? vm.singleColumnName[0] : ""), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("label", _hoisted_10, _toDisplayString(_unref($t)("TargetField")), 1),
        _createVNode(Dropdown, {
          modelValue: vm.artNrType,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((vm.artNrType) = $event)),
          items: artNrTypeFields.value,
          "value-field": "value",
          "text-field": "text"
        }, {
          "item-template": _withCtx(({ entry }) => [
            entry
              ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(entry.text), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue", "items"])
      ])
    ])
  ]))
}
}

})